// extracted by mini-css-extract-plugin
export var logo_train = "logo_train-5Ce";
export var logos_container = "logos_container-vNe";
export var scroll = "scroll-OiY";